export const formatter = new Intl.NumberFormat("pt-BR", {
	style: "currency",
	currency: "BRL"
});

export const formattedPhoneNumber = (phone: string) => {
	if (phone.length === 10) {
		return `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
	}
	return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
};

export const formattedPhoneNumber0800 = (phone: string) => {
	return `${phone.slice(0, 4)} ${phone.slice(4, 7)} ${phone.slice(7)}`;
};

export const truncateTextWithEllipsis = (text: string, maxSize = 20) => {
	return text.length > maxSize ? `${text?.substring(0, maxSize)}...` : text;
};
